import { type IDocument, type IShopifyLineItem } from "@types";

// A Shopify cart line carries the ids of the documents it represents — several
// when it's a bundle. Returns the line ids that reference at least one document
// which no longer exists; a bundle line is stale as soon as any single contained
// document is gone. Lines with no document ids are always kept, so a line
// unrelated to documents is never touched (and a line missing the field entirely
// can't crash the check, which runs in a route guard).
export const findStaleLineIds = (
  lines: IShopifyLineItem[],
  existingDocumentIds: Set<IDocument["id"]>,
): IShopifyLineItem["lineId"][] =>
  lines
    .filter((line) => {
      const documentIds = line.externalDocumentIds ?? [];

      return documentIds.length > 0 && documentIds.some((id) => !existingDocumentIds.has(id));
    })
    .map((line) => line.lineId);
